import React from "react";

// Institutional statement — text only, uses default site fonts, no images.
export default function AboutFinance() {
  return (
    <section
      id="ashir-finance"
      data-testid="about-finance-section"
      className="relative bg-[#05070D] py-24 md:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#D4AF37]/70" />
            <span className="text-[10px] tracking-[0.32em] uppercase text-[#D4AF37] font-medium">
              ASHIR FINANCE
            </span>
            <span className="w-8 h-px bg-[#D4AF37]/70" />
          </div>
          <h2
            data-testid="about-finance-headline"
            className="font-serif-ag text-white text-3xl md:text-4xl lg:text-[3rem] font-light leading-[1.1] tracking-[-0.015em]"
          >
            Estruturação e intermediação de{" "}
            <span className="italic text-[#D4AF37]">
              negócios imobiliários e financeiros
            </span>
            .
          </h2>
        </div>

        <div className="space-y-8 max-w-3xl mx-auto">
          <p
            data-testid="about-finance-p1"
            className="text-[#D6DBE2] text-lg md:text-xl font-light leading-[1.85] text-center md:text-left"
          >
            A <span className="text-white">ASHIR FINANCE</span> atua na
            estruturação e intermediação de negócios imobiliários e
            financeiros, identificando oportunidades de crédito com garantia de
            imóvel para seus clientes e encaminhando essas oportunidades a
            instituições financeiras parceiras.
          </p>

          <div className="w-16 h-px bg-[#D4AF37]/40 mx-auto md:mx-0" />

          <p
            data-testid="about-finance-p2"
            className="text-[#D6DBE2] text-lg md:text-xl font-light leading-[1.85] text-center md:text-left"
          >
            Buscamos disponibilizar aos nossos clientes uma{" "}
            <span className="text-white">alternativa de crédito com garantia imobiliária</span>{" "}
            que possa viabilizar operações de aquisição, investimento,
            desenvolvimento e negócios imobiliários.
          </p>
        </div>
      </div>
    </section>
  );
}
